const PaymentState = {
    createTelerPayment: [],
    telerPaymentCreated: false,
    checkTelerPayment: [],
    paymentMethod:""
}
export default PaymentState;